import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Classification } from '../../../models/classification.model';
import { DataTableService } from '../../../modules/UIKit/components/dataTable/dataTable.service';
import { DataTableCustomButton } from '../../../modules/UIKit/components/dataTable/dataTableCustomButton.interface';
import { DataTableField } from '../../../modules/UIKit/components/dataTable/dataTableField.interface';
import { KontableComponent } from '../../../modules/UIKit/components/kontable/kontable.component';
import { ClassificationService } from '../../../services/classification/classification.service';

@Component({
    selector: 'app-classification-list',
    templateUrl: './classification-list.component.html'
})
export class ClassificationListComponent implements OnInit {

  @Output() customButton = new EventEmitter();

  titles: DataTableField[];
  customButtons: DataTableCustomButton[];
  activeView = 'list';
  customFilter = KontableComponent.CustomFilter;
  newDataAvailable = false;
  modalTitle = '';
  labels = {}

  constructor(
    public svc: ClassificationService,
    private srvDataTable: DataTableService,
    private translate: TranslateService) {
      this.translate.get([
        'common.classification_parent',
        'common.certification_name',
        'common.classification_type',
        'common.classification_custom_types',
        'common.classification_custom_showdetail'
      ]).subscribe((res) => {
          this.titles = [
            { id: 'id', label: '#' },
            { id: 'parent.name', label: res['common.classification_parent'] },
            { id: 'name', label: res['common.certification_name'] },
            { id: 'classification_type.name', label: res['common.classification_type'] },
          ];

      this.customButtons = [
        {
          isAlwaysEnabled: true,
          label: res['common.classification_custom_types'],
          callbackname: 'classification_types',
          icon: 'fa fa-detail'
        },
        {
          isAlwaysEnabled: false,
          label: res['common.classification_custom_showdetail'],
          callbackname: 'classification_detail',
          icon: 'fa fa-detail'
        }
      ]
    });
  }

  ngOnInit() {

    this.translate.get([
      'classificationList.add_title',
      'classificationList.edit_title'
    ]).subscribe((res) => {
      this.labels['add_title'] = res['classificationList.add_title'];
      this.labels['edit_title'] = res['classificationList.edit_title'];
    });

    this.reloadList();
  }

  reloadList() {
    this.activeView = 'list';
    this.svc.getList().subscribe( () => {
      this.newDataAvailable = true;
    });
  }

  showAddOrEditDialog(data): void {
    this.modalTitle = data == null ? this.labels['add_title'] : this.labels['edit_title'];
    this.svc.editing = data == null ? new Classification() : data;
    console.log(this.svc.editing)
  }

  delete (entry): void {
    this.svc.delete(entry).subscribe( () => {
      this.reloadList ();
    });
  }

  onAddElement(entry): void {
    this.svc.post(entry).subscribe(() => {
      this.srvDataTable.get('dt_classification').showDetail = false;
      this.svc.editing = null;
      this.reloadList ();
    });
  }

  onUpdateElement(entry): void {
    this.svc.put(entry).subscribe(() => {
      this.srvDataTable.get('dt_classification').showDetail = false;
      this.svc.editing = null;
      this.reloadList ();
    });
  }

  onCustomButton(event) {
    console.log(event);
    switch (event['callbackName']) {
      case 'classification_types':
        this.activeView = 'types';
        break;
      case 'classification_detail':
        this.activeView = 'details';
        break;
    }
  }

  onItemClick(entry) {
    this.svc.editing = entry;
    console.log(entry);
  }

  onDialogHide() {
    this.svc.editing = null;
  }

  customButtonClick (event) {
    this.customButton.emit (event);
  }

  parentFilterFun (event, row, table) {
    table.updateTableFilter(row.field, event.target.value, 'equals');
  }

  valueTypeFilterFun (event, row, table) {
    table.updateTableFilter(row.field, event.target.value, 'equals');
  }

}



// WEBPACK FOOTER //
// ./src/app/views/classification/classification-list/classification-list.component.ts